import { gql } from "@apollo/client";

export const UpdateInstalledBaseIotReportSubscription = gql`
    mutation UpdateInstalledBaseIotReportSubscription ($id: ID!, $input: InstalledBaseIotReportSubscriptionInput!) {
        updateInstalledBaseIotReportSubscription(id: $id, input: $input) {
            id
            inApp
            mail
            push
            insert
            update
            client {
                id
                name
            }
        }
    }
`;
